import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import routerData from './modules/routerData'
import role from './modules/role'
import layout from './modules/layout/index'
import axios from '@/request/http'
import global from '@/constants/Global.constants'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: Cookies.get(`token_${window.location.port}`),
    allUser: [],
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      Cookies.set(`token_${window.location.port}`, token, { expires: 1 })
    },
    setAllUser(state, payload) {
      state.allUser = payload
    },
  },
  actions: {
    setToken ({commit}, token) {
      return new Promise((resolve, reject) => {
        commit('setToken', token)
        resolve()
      })
    },
    setAllUser ({ commit }, payload) {
      let user = JSON.parse(localStorage.getItem('user'))
      axios.post(global.BASE_INFO + '/user/findUserBaseInfo',{
        data:{ categoryCode: "staff"},pageIndex: 0, pageSize: 9999, asp: user.asp
      }).then(res => {
        commit('setAllUser', res.data.data)
      })
    },
  },
  getters: {
    addRouters: state => state.routerData.addRouters,
    token: state => state.token,
    info: state => state.role.info,
    routers: state => state.routerData.routers,
    logoShow: state => state.layout.logoShow,
    isCollapse: state => state.layout.isCollapse,
    uniquerouter: state => state.layout.uniquerouter,
    tabnavBox: state => state.layout.tabnavBox,
    visible: state => state.layout.visible,
    left: state => state.layout.left,
    top: state => state.layout.top,
    rightNav: state => state.layout.rightNav,
    allUser: state => state.allUser,
  },
  modules: {
    routerData,
    role,
    layout
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/index.js